import { z } from "astro/zod";
import { citySchema } from "./city";
import { countrySchema } from "./country";

export const cityCountrySchema = z.object({
  city: citySchema,
  country: countrySchema,
  lat: z.string().min(1),
  lng: z.string().min(1),
});
